import { Flex, Text } from "@chakra-ui/react";
import { XIcon } from "@phosphor-icons/react";
import { IconButton } from "barte-design-system";

interface ItemProps {
  text: string;
  handleDelete: (index: number) => void;
  index: number;
  onClick?: () => void;
}

const Item = ({ text, handleDelete, index, onClick }: ItemProps) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      h="40px"
      px="2"
      borderRadius="var(--border-radius-sm)"
      cursor="pointer"
      onClick={onClick}
      bg="var(--bg-secondary)"
    >
      <Text noOfLines={1} fontSize="14px" color="var(--content-primary)">
        {text}
      </Text>
      <IconButton
        variant="ghost"
        size="sm"
        aria-label="Remover item"
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(index);
        }}
      >
        <XIcon size={16} />
      </IconButton>
    </Flex>
  );
};

export { Item };
